import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {MatIconModule} from '@angular/material/icon';
import { HttpClientModule } from '@angular/common/http';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { DateAdapter, MatNativeDateModule } from '@angular/material/core';
import { CalendarService } from './services/calendar.service';
import { CustomDateAdapterService } from './services/custom-date-adapter.service';
import { DateDropdownComponent } from './shared/date-dropdown/date-dropdown.component';
 

@NgModule({
  declarations: [
    AppComponent,
    DateDropdownComponent,
    // HeaderComponent
  ],
  imports: [
    // BrowserModule,
    // AppRoutingModule,
    // BrowserAnimationsModule,
    // MatButtonModule,
    // MatFormFieldModule,
    // MatInputModule,
    // FormsModule,
    // ReactiveFormsModule,
    // MatIconModule,
    // HttpClientModule,
    
    // CalendarModule.forRoot({
    //   provide: DateAdapter,
    //   useFactory: adapterFactory,
    // })
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatSelectModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    MatNativeDateModule,
  ],
  providers: [CalendarService, { provide: DateAdapter, useClass: CustomDateAdapterService}],
  bootstrap: [AppComponent]
})
export class AppModule { }
